import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { AppAbilityType } from '../../components/ability/ability';
import { AbilityContext } from '../../components/ability/can';
import { ViewSwitcher } from '../../components/viewSwitcher/ViewSwitcher';
import { flattenObject } from '../usePageState';
import { DEFAULT_BILL_FILES_FILTERS } from './billFilesSidebar/BillFilesSidebarFiltersContext';

export const CUSTOMER_UTILITY_BILL_VIEW = {
    BILLS: '/reporting/customer-utility-bills',
    FILES: '/reporting/customer-utility-bills/files',
} as const;

export const customerUtilityBillViewInterface = (userAbility: AppAbilityType) =>
    userAbility.can('view-route', CUSTOMER_UTILITY_BILL_VIEW.BILLS) && userAbility.can('view-route', CUSTOMER_UTILITY_BILL_VIEW.FILES)
        ? [
              {
                  title: 'Bills',
                  value: CUSTOMER_UTILITY_BILL_VIEW.BILLS,
                  tooltip: 'Bills',
                  isVisible: true,
              },
              {
                  title: 'Files',
                  value: CUSTOMER_UTILITY_BILL_VIEW.FILES,
                  tooltip: 'Files',
                  isVisible: true,
              },
          ]
        : [];

// Bills / Files tab switcher. Filters are per-tab, so switching drops the query string (keeping only companyId);
// switching to Files applies its default filter.
export const CustomerUtilityBillViewSwitcher = () => {
    const ability = useContext(AbilityContext);
    const location = useLocation();
    const navigate = useNavigate();

    const onViewChange = (view: string) => {
        const companyId = new URLSearchParams(location.search).get('companyId');
        const search = queryString.stringify(
            flattenObject({
                companyId,
                ...(view === CUSTOMER_UTILITY_BILL_VIEW.FILES && { filter: DEFAULT_BILL_FILES_FILTERS }),
            }),
            { arrayFormat: 'comma', skipNull: true }
        );
        navigate(`${view}${search ? `?${search}` : ''}`);
    };

    return <ViewSwitcher viewOptions={customerUtilityBillViewInterface(ability)} view={location.pathname} handleViewMode={onViewChange} />;
};
